export default {
  name: "nftInfo",
  data() {
    return {
      devicePixelRatio: 1
    };
  },
  created() {
    this.devicePixelRatio = window.devicePixelRatio;
    console.log("this.devicePixelRatio", this.devicePixelRatio);
  }
};